<div class="container d-none d-md-block" style="margin-top: 70px">
  <div class="row">
    <div class="col-md-6">
      <h1 class="title">
        <strong> ¡Ups! </strong>
      </h1>
      <h2 class="code" style="margin-top: 150px" translate>
        components.error.Código de error: 404
      </h2>

      <br /><br /><br />

      <span class="text1" translate>components.error.text1</span>

      <br /><br /><br />

      <span class="text2" translate> components.error.text2 </span>
      <br /><br /><br /><br />

      <a class="home" href="/">Home</a>
      <br /><br />
      <a
        class="compra"
        href="#"
        [routerLink]="[
          (translateService.currentLang === 'es' ? '/es' : '/en') + '/invertir'
        ]"
        translate
      >components.error.Compra</a
      >
      <br /><br />
      <a
        class="vende"
        href="#"
        [routerLink]="[
          (translateService.currentLang === 'es' ? '/es' : '/en') +
            '/vende'
        ]"
        translate
      >components.error.Vende</a
      >
      <br /><br />
      <a
        class="comofunciona"
        href="#"
        [routerLink]="[
          (translateService.currentLang === 'es' ? '/es' : '/en') +
            '/sobre-nosotros/como-trabajamos'
        ]"
        translate
      >components.error.Cómo funciona</a
      >
    </div>
    <div class="d-flex align-items-center justify-content-end col-md-6">
      <img
        id="img"
        loading="lazy"
        src="{{ picturesServer }}img/404.png"
        alt="imagen 404"
      />
    </div>
  </div>
</div>

<!--version mobile-->
<div class="container d-block d-sm-block d-md-none" style="margin-top: 70px">
  <div class="row">
    <div class="responsive col-md-6">
      <h2 class="ups text-center">
        <strong> ¡Ups! </strong>
      </h2>
      <h2 class="codeMobile text-center" style="margin-top: 30px" translate>
        components.error.Código de error: 404
      </h2>

      <br />

      <img
        loading="lazy"
        src="{{ picturesServer }}img/404-mobile.jpg"
        style="width: 321px; height: 195px"
        alt="imagen alerta"
      />
      <br /><br />

      <span class="text1Mobile text-center" translate
      >components.error.text1</span
      >
      <br /><br /><br />
      <span class="text2Mobile text-center" translate>
        components.error.text2
      </span>
      <br /><br />

      <div class="text-center">
        <a class="homeMobile" href="/">Home</a>
      </div>
      <br />
      <div class="text-center">
        <a
          class="compraMobile"
          href="#"
          [routerLink]="[
            (translateService.currentLang === 'es' ? '/es' : '/en') +
              '/invertir'
          ]"
          translate
        >components.error.Compra</a
        >
      </div>
      <br />
      <div class="text-center">
        <a
          class="vendeMobile"
          href="#"
          [routerLink]="[
            (translateService.currentLang === 'es' ? '/es' : '/en') +
              '/vende'
          ]"
          translate
        >components.error.Vende</a
        >
      </div>
      <br />
      <div class="text-center">
        <a
          class="comofuncionaMobile"
          href="#"
          [routerLink]="[
            '/' +
              translateService.currentLang +
              '/sobre-nosotros/como-trabajamos'
          ]"
          translate
        >components.error.Cómo funciona</a
        >
      </div>
    </div>
  </div>
</div>
